export const isPeopleRegex = "^/(?:hosted/)?places/people/?$";
